import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import { 
    IS_WAITING, 
    IS_OPEN_NOTIF, 
    MODULE_PAGE_TITLE, 
    IS_OPEN_IS, 
    IS_OPEN_PROFILE,
    // OPEN_MODAL 
} from './Action';

export const waiting = (state = { is_waiting: false }, action) => {
    if(action.type === IS_WAITING) {
        return Object.assign({}, state, { is_waiting: action.is_waiting })
    }
    return state;
}

/*export const modal = (state = { modalType: '', open: false}, action) => {
    if(action.type === OPEN_MODAL) {
        return Object.assign({}, state, {
            modalType: action.modalType,
            open: action.open
        })
    }
    return state;
}*/

export const header = (state = { isOpenNotif: false, pageTitle: '', isOpenIs: false, isProfileOpen: false }, action) => {
    switch(action.type) {
        case IS_OPEN_PROFILE:
            return Object.assign({}, state, {
                isProfileOpen: action.open,
                isOpenNotif:false,
                isOpenIs: false
            })
        case IS_OPEN_NOTIF:
            return Object.assign({}, state, {
                isOpenNotif: action.open,
                isOpenIs: false,
                isProfileOpen: false
            })
        case IS_OPEN_IS:
            return Object.assign({}, state, {
                isOpenIs: action.open,
                isOpenNotif: false,
                isProfileOpen: false
            })
        case MODULE_PAGE_TITLE:
            return Object.assign({}, state, {
                pageTitle: action.title
            })
        default:
            return state;
    }
}

const app = combineReducers({
    routing: routerReducer,
    waiting,
    // modal,
    header,
    modal: require('./common/reducers').modal,
    payment: require('./payment/reducers')
})

export default app;



/** WEBPACK FOOTER **
 ** ./src/Reducers.js
 **/